// extracted by mini-css-extract-plugin
export default {"box":"rPE7lQkP6buI7gkkFY0n"};